export const getPreviousRef = (childNodes: NodeListOf<ChildNode>, ref: HTMLDivElement) => {
  let wanted

  for (const node of childNodes.values()) {
    if (node === ref && wanted) break
    wanted = node
  }

  return wanted
}

export const getRefWithId = (childNodes: NodeListOf<HTMLElement>, id?: string) => {
  let wanted

  for (const node of childNodes.values()) {
    if (node.id === id) {
      wanted = node
      break
    }
  }

  return wanted
}